// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

const opts = {
    theme: {
        themes: {
          light: {
            primary: colors.orange.darken4, 
            secondary: colors.red.lighten4, // #FFCDD2
            accent: colors.indigo.base, // #3F51B5
            main: "#304241",
            second:"#2d3e56",
            third:"#67c293",
            alert: "#ff8049"
          },
        },
      },
    
}

export default new Vuetify(opts)